import currenciesService from './currencies';
import accountsService from './accounts';
import Service from './abstract';
import _ from 'lodash';

const withAccountsOrigin = 'accounts,accountOrigin,accountOrigin.wallet,accountOrigin.currency,accountOrigin.currency.attributes,accountOrigin.currency.attributes.attribute';
const withAccountsDestination = 'accountDestination,accountDestination.wallet,accountDestination.currency,accountDestination.currency.attributes,accountDestination.currency.attributes.attribute';
const defaultWith = `transfer_type,type,status,currency,currency.attributes,currency.attributes.attribute,${withAccountsOrigin},${withAccountsDestination}`;
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith
};
const defaultOptionsGetById = {
    with: defaultWith
};

class Schedulers extends Service {
    constructor () {
        super('transfers');
    }

    get defaultOptionsFind () {
        return defaultOptionsFind;
    }

    get defaultOptionsGetById () {
        return defaultOptionsGetById;
    }

    find (options = {}) {
        return super.find({
            url: `${this.basePath}/schedulers`,
            qs: _.defaultsDeep({}, options, this.defaultOptionsFind)
        });
    }

    create (options = {}) {
        return super.post({
            url: `${this.basePath}/schedulers`,
            data: options
        });
    }

    execute (id, options = {}) {
        return super.put({
            url: `${this.basePath}/schedulers/${id}/execute`,
            data: options
        });
    }

    cancel (id, options = {}) {
        return super.put({
            url: `${this.basePath}/schedulers/${id}/cancel`,
            data: options
        });
    }

    normalize (scheduler) {
        if (_.isNil(scheduler)) {
            return scheduler;
        }

        // Prepare default properties
        scheduler = super.normalize(scheduler);

        // Prepare accounts
        if (scheduler.accounts) {
            if (scheduler.accounts.origin) {
                scheduler.accounts.origin = accountsService.normalize(scheduler.accounts.origin);
            }
            if (scheduler.accounts.destination) {
                scheduler.accounts.destination = accountsService.normalize(scheduler.accounts.destination);
            }
        }

        // Prepare currency
        if (scheduler.currency) {
            scheduler.currency = currenciesService.normalize(scheduler.currency);
        }
        return scheduler;
    }
}

export default new Schedulers();
